<template>
    <div class="modal is-active">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("prepare-text.text-field") }}
                </p>
                <button class="delete" @click="close"></button>
            </header>
            <section class="modal-card-body">
                <div class="field">
                    <label class="label">{{
                        $t("prepare-text.question-title")
                    }}</label>
                    <div class="control">
                        <input
                            class="input"
                            :class="{ 'is-danger': missingTitle }"
                            type="text"
                            v-model="title"
                        />
                        <p v-if="missingTitle" class="help is-danger">
                            {{ $t("prepare-text.is-required-question-title") }}
                        </p>
                    </div>
                </div>

                <UsersSelect v-model="selectedUsers" />
            </section>
            <footer class="modal-card-foot is-justify-content-flex-end">
                <button class="button" @click="send">
                    <Icon
                        name="fa-paper-plane"
                        helperClass="has-text-primary"
                    />
                    <span>{{ $t("prepare-text.send") }}</span>
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import UsersSelect from "../UsersSelect.vue";

export default {
    name: "prepare-text",
    components: {
        UsersSelect,
    },
    data() {
        return {
            title: "",
            missingTitle: false,
            selectedUsers: [],
        };
    },
    methods: {
        close() {
            this.$emit("close");
        },
        send() {
            this.missingTitle = this.title === "";

            if (this.missingTitle) {
                return;
            }

            for (let i = 0; i < this.selectedUsers.length; i++) {
                const selectedUser = this.selectedUsers[i];
                this.$emit("sendAction", {
                    type: "text",
                    title: this.title,
                    state: 0,
                    user: selectedUser,
                });
            }
        },
    },
};
</script>